var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selectedComponent,{tag:"component",attrs:{"doLoadComponent":_vm.loadComponent,"renderData":_vm.renderData}})}
var staticRenderFns = []

export { render, staticRenderFns }